export enum BYTE_ORDER {
  'raw' = 'Raw Data',
  'normal' = 'High/low word swap',
  'reversed' = 'Reversed'
}